var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GeminiSummaryMetricLine, GeminiSummarySlashPair } from '@web/components/Apps/Gemini/geminiSummaryCards';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { SummaryCardLabel, SummaryCardShell } from '@web/components/layout/SummaryCards/SummaryCards';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
var formatTeamDiff = function (teamAverage) { var _a; return (_a = teamAverage === null || teamAverage === void 0 ? void 0 : teamAverage.diffString) !== null && _a !== void 0 ? _a : ''; };
var buildCsvRows = function (data, t, showTeamDiff) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var teamDiffKey = showTeamDiff
        ? t('app.apps.drive.summary.export.teamDiff')
        : null;
    var withTeamDiff = function (row, metric) {
        var _a;
        return teamDiffKey
            ? __assign(__assign({}, row), (_a = {}, _a[teamDiffKey] = formatTeamDiff(metric.teamAverage), _a)) : row;
    };
    return [
        withTeamDiff((_a = {},
            _a[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.createdDocuments'),
            _a[t('app.apps.drive.summary.export.value')] = data.created.count,
            _a[t('app.apps.drive.summary.export.diff')] = data.created.previous.diffString,
            _a), data.created),
        withTeamDiff((_b = {},
            _b[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.edited'),
            _b[t('app.apps.drive.summary.export.value')] = data.edited.count,
            _b[t('app.apps.drive.summary.export.diff')] = data.edited.previous.diffString,
            _b), data.edited),
        withTeamDiff((_c = {},
            _c[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.viewed'),
            _c[t('app.apps.drive.summary.export.value')] = data.viewed.count,
            _c[t('app.apps.drive.summary.export.diff')] = data.viewed.previous.diffString,
            _c), data.viewed),
        withTeamDiff((_d = {},
            _d[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.commentsAdded'),
            _d[t('app.apps.drive.summary.export.value')] = data.commentsAdded.count,
            _d[t('app.apps.drive.summary.export.diff')] = data.commentsAdded.previous.diffString,
            _d), data.commentsAdded),
        withTeamDiff((_e = {},
            _e[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.commentsResolved'),
            _e[t('app.apps.drive.summary.export.value')] = data.commentsResolved.count,
            _e[t('app.apps.drive.summary.export.diff')] = data.commentsResolved.previous.diffString,
            _e), data.commentsResolved),
        withTeamDiff((_f = {},
            _f[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.suggestionsAdded'),
            _f[t('app.apps.drive.summary.export.value')] = data.suggestionsAdded.count,
            _f[t('app.apps.drive.summary.export.diff')] = data.suggestionsAdded.previous.diffString,
            _f), data.suggestionsAdded),
        withTeamDiff((_g = {},
            _g[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.suggestionsResolved'),
            _g[t('app.apps.drive.summary.export.value')] = data.suggestionsResolved.count,
            _g[t('app.apps.drive.summary.export.diff')] = data.suggestionsResolved.previous.diffString,
            _g), data.suggestionsResolved),
        withTeamDiff((_h = {},
            _h[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.shared'),
            _h[t('app.apps.drive.summary.export.value')] = data.shared.count,
            _h[t('app.apps.drive.summary.export.diff')] = data.shared.previous.diffString,
            _h), data.shared),
        withTeamDiff((_j = {},
            _j[t('app.apps.drive.summary.export.metric')] = t('app.apps.drive.summary.sharedExternally'),
            _j[t('app.apps.drive.summary.export.value')] = data.sharedExternally.count,
            _j[t('app.apps.drive.summary.export.diff')] = data.sharedExternally.previous.diffString,
            _j), data.sharedExternally)
    ];
};
var toMetricLineProps = function (metric, showTeamDiff) { return ({
    value: String(metric.count),
    prevPeriodDiff: metric.previous,
    teamAvgDiff: showTeamDiff ? metric.teamAverage : undefined
}); };
function DriveSummary() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var _b = trpc.driveSummary.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamDiff = Boolean(user);
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.apps.drive.summary.title'), description: "widgetTitleDescriptions.apps.driveSummary", insightType: InsightTypeEnum.driveSummary, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.apps.drive.summary.title'), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, buildCsvRows(data, t, showTeamDiff)];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5" }, { children: [_jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.drive.summary.createdDocuments') }), _jsx(GeminiSummaryMetricLine, __assign({}, toMetricLineProps(data.created, showTeamDiff)))] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.drive.summary.editedViewed') }), _jsx(GeminiSummarySlashPair, { left: toMetricLineProps(data.edited, showTeamDiff), right: toMetricLineProps(data.viewed, showTeamDiff) })] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.drive.summary.commentsAddedResolved') }), _jsx(GeminiSummarySlashPair, { left: toMetricLineProps(data.commentsAdded, showTeamDiff), right: toMetricLineProps(data.commentsResolved, showTeamDiff) })] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.drive.summary.suggestionsAddedResolved') }), _jsx(GeminiSummarySlashPair, { left: toMetricLineProps(data.suggestionsAdded, showTeamDiff), right: toMetricLineProps(data.suggestionsResolved, showTeamDiff) })] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.drive.summary.sharedSharedExternally') }), _jsx(GeminiSummarySlashPair, { left: toMetricLineProps(data.shared, showTeamDiff), right: toMetricLineProps(data.sharedExternally, showTeamDiff) })] })] }))] }));
}
export default DriveSummary;
